export default __webpack_public_path__ + "static/media/icono_filtro.0da72e0f.svg";